module.exports = __webpack_public_path__ + "static/media/appdrawer_white.c6a71acb.svg";